import Vue from 'vue'

export default (context, inject) => {
  const eventBus = new Vue()
  inject('eventBus', eventBus)
}
